import React, { useState, useEffect } from "react";
import "rc-slider/assets/index.css";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import SessionControl from "../../components/SessionControl/sessioncontrol";


const ExpenseForm = () => {
  const [formData, setFormData] = useState({
    restaurantName: "restaurant de test",
    address: "22 rue de la Paix, Paris",
    phone: "65 123 45 67",
    devise: "XAF, XOF, Euro",
    category: "",

  });

  const [prenom, setPrenom] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const usersession = JSON.parse(storedUser);
      console.log("usersession :", usersession);
      setPrenom(usersession.prenom); 
    }
  }, []);


  const categories = [
    "Traditionnel",
    "Fast-food",
    "Vegans",
    "Buffet à volonté",
    "Café et salon de thé",
    "Buvette et restaurant de rue",
    "Autres"
  ];


  const [selected, setSelected] = useState([]);


  const toggleCategory = (category) => {
    setSelected((prevSelected) =>
      prevSelected.includes(category)
        ? prevSelected.filter((c) => c !== category)
        : [...prevSelected, category]
    );
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
   const route = all_routes;
   const [logo, setLogo] = useState(null);
  return (
            <div className="page-wrapper">
                <SessionControl
                    storageKey="user"
                    propsup="email"
                    redirectTo={route.signin}
                />
                <div className="content">
                        <div className="login-userheading">
                            <h2 style={{ color: "#000", textAlign: "left" }}>Découvrons votre restaurant {prenom}!  </h2>
                            <h5 style={{ width: "100%", textAlign: "left" }}>Partagez avec nous l&apos;univers de votre enseigne et ce qui la rend unique !</h5>
                        </div>
                    <div className="card mt-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-sm-12">
                                    <div className="input-blocks">
                                        <label>Nom de votre restaurant </label>
                                        <div className="form-addons input-icon">
                                        <input type="text" 
                                            name="restaurantName" 
                                            className="form-control" 
                                            placeholder={formData.restaurantName}
                                            onChange={handleChange}
                                        />
                                        <i className="las la-utensils input-icon-abs"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-12">
                                    <div className="input-blocks">
                                    <label>Adresse</label>
                                        <div className="form-addons input-icon">
                                        <input type="text" 
                                            name="address" 
                                            className="form-control" 
                                            placeholder={formData.address}
                                            onChange={handleChange}
                                        />
                                        <i className="las la-map-marker-alt input-icon-abs"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-12">
                                    <div className="input-blocks">
                                        <label>Numéro de téléphone (optionnel)</label>
                                        <div className="form-addons input-icon">
                                        <input type="text" 
                                            name="phone" 
                                            className="form-control" 
                                            placeholder={formData.phone}
                                            onChange={handleChange}
                                        />
                                        <i className="las la-phone input-icon-abs"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-12">
                                    <div className="input-blocks">
                                        <label>Monnaie utilisée</label>
                                        <div className="form-addons">
                                        <input type="text" 
                                            name="devise" 
                                            className="form-control" 
                                            placeholder={formData.devise}
                                            onChange={handleChange}
                                        />
                                        </div>
                                    </div>
                                </div>
                                 <div className="input-blocks">
                                    <label>Logo du restaurant</label>
                                    <div className="form-addons input-icon">
                                        <input
                                        type="file"
                                        accept="image/*"
                                        className="form-control"
                                        onChange={e => {
                                            if (e.target.files && e.target.files[0]) {
                                            setLogo(URL.createObjectURL(e.target.files[0]));
                                            }
                                        }}
                                        />
                                        <i className="las la-image input-icon-abs"></i>
                                    </div>
                                    {logo && (
                                        <div style={{ marginTop: 10 }}>
                                        <img src={logo} alt="Logo aperçu" style={{ height: 60, borderRadius: 8 }} />
                                        </div>
                                    )}
                                </div>
                                <div className="input-blocks ">
                                    <label>Catégorie de votre restaurant</label>
                                    <div className="category-buttons mt-3">
                                        {categories.map((category) => (
                                        <button
                                            type="button"
                                            key={category}
                                            className={`category-button ${
                                            selected.includes(category) ? "selected" : ""
                                            }`}
                                            onClick={() => toggleCategory(category)}
                                        >
                                            {category}
                                        </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="col-12 text-end">
                                    <Link to={route.articles} className="btn btn-submit me-2">
                                    Continuer
                                    </Link>
                                </div>
                            </div>
                        </div>
                   </div>
                </div>
            </div>

  );
};

export default ExpenseForm;